import Operator from '@/lib/Operator';
import {Question} from '@/lib/Question';
import store from '@/store';
import Section from "@/lib/Section";

export default class Condition {
    public isFulfilled: boolean = false;
    private testingQuestion?: Question;

    constructor(
        public id: number,
        public operator: Operator,
        public testingQuestionId: number,
        public value: string,
    ) {
    }

    public check() {
        if (!this.testingQuestion || !this.testingQuestion.currentResponse) {
            this.isFulfilled = false;
        }
        if (!this.testingQuestion) {
            this.isFulfilled = true;
            return;
        }
        if (!this.testingQuestion!.currentResponse) {
            this.isFulfilled = false;
            return;
        }
        const responseValue = this.testingQuestion!.responseType.code === 'entity'
            ? this.testingQuestion!.currentResponse.valueId : this.testingQuestion!.currentResponse.value;
        this.isFulfilled = this.operator.test(responseValue, this.value) as boolean;
    }


    public getTestingQuestion(): Question {
        if (!this.testingQuestion) {
            this.testingQuestion = store.getters.getQuestion(this.testingQuestionId);
        }
        return this.testingQuestion!;
    }

    public init() {
        const testingQuestion = this.getTestingQuestion();
        if (testingQuestion) {
            testingQuestion.changedEvent.on(() => {
                this.check();
            });
        } else {
            // console.warn('no testing question set yet');
        }

    }
}
